// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3IcsD","description":"PatientConsentPreview_description__37oZ2"};